import { withRouter } from 'react-router-dom';
import Header from './header';

export default withRouter(Header);
